import { encryptData, decryptData } from "./cryptoUtils";

// Admin Local Storage Functions
const clearAdminLocalStorage = () => {
  localStorage.removeItem("adminData");
  localStorage.removeItem("adminIsLoggedIn");
  localStorage.removeItem("adminSessionExpired");
};

const saveAdminToLocalStorage = (admin) => {
  const encryptedAdmin = encryptData(JSON.stringify(admin));
  if (encryptedAdmin) {
    localStorage.setItem("adminIsLoggedIn", encryptData("true"));
    localStorage.setItem("adminData", encryptedAdmin);
    localStorage.removeItem("adminSessionExpired");
  } else {
    console.error("Failed to save admin data to local storage");
  }
};

const getAdminFromLocalStorage = () => {
  const loggedInEncrypted = localStorage.getItem("adminIsLoggedIn");
  const encryptedAdmin = localStorage.getItem("adminData");
  const sessionExpiredEncrypted = localStorage.getItem("adminSessionExpired");

  const sessionExpired = sessionExpiredEncrypted
    ? decryptData(sessionExpiredEncrypted) === "true"
    : false;

  const storedAdmin = encryptedAdmin ? JSON.parse(decryptData(encryptedAdmin)) : null;
  const loggedIn = loggedInEncrypted
    ? decryptData(loggedInEncrypted) === "true"
    : false;

  return { loggedIn, storedAdmin, sessionExpired };
};


// User Local Storage Functions
const clearUserLocalStorage = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("userIsLoggedIn");
  localStorage.removeItem("userSessionExpired");
};

const saveUserToLocalStorage = (user) => {
  const encryptedUser = encryptData(user);
  if (encryptedUser) {
    localStorage.setItem("userIsLoggedIn", encryptData("true"));
    localStorage.setItem("user", encryptedUser);
    localStorage.removeItem("userSessionExpired");
  } else {
    console.error("Failed to save user to local storage");
  }
};

const getUserFromLocalStorage = () => {
  const loggedInEncrypted = localStorage.getItem("userIsLoggedIn");
  const userEncrypted = localStorage.getItem("user");
  const sessionExpiredEncrypted = localStorage.getItem("userSessionExpired");

  const loggedIn = loggedInEncrypted
    ? decryptData(loggedInEncrypted) === "true"
    : false;
  const storedUser = userEncrypted ? decryptData(userEncrypted) : null;
  const sessionExpired = sessionExpiredEncrypted
    ? decryptData(sessionExpiredEncrypted) === "true"
    : false;

  return { loggedIn, storedUser, sessionExpired };
};

export {
  clearAdminLocalStorage,
  saveAdminToLocalStorage,
  getAdminFromLocalStorage,
  clearUserLocalStorage,
  saveUserToLocalStorage,
  getUserFromLocalStorage,
};
